<template>
  <img :src="src" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatPlaceholder",
  props: {
    id: {
      type: [String, Number]
    },
    width: String,
    height: String
  },
  data: function () {
    return {
      src:
        "https://via.placeholder.com/" + this.width + "x" + this.height + ".png"
    };
  }
});
</script>
